import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function useLoginPageTitle() {
  useEffect(() => {
    document.title = "ログイン";
    return () => {
      document.title = "奥村トレーサビリティ";
    };
  }, []);
}
export function usePageTitle() {
  const location = useLocation();
  useEffect(() => {
    document.title = `${getPageTitle(location.pathname)}`;
    return () => {
      document.title = "不明なページ";
    };
  }, [location]);
}

export function getPageTitle(path: string) {
  //完全一致
  if (path === "/system-admin/toppage") return "トップページ";

  let suffix = ""
  //if (/^\/[^/]+\/\d+$/.test(path)) suffix = " 詳細";

  return "奥村トレーサビリティ";
}
